import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import ChannelCard from './components/ChannelCard';
import s from './s.module.less';
import { useRequest } from 'ahooks';
import { getLiveChannelList } from 'api/channel';
import { CALENDLY_TYPE, Channel, ChannelItem, EWebinarScheduleType, CouponType } from 'types/common';
import { message, Modal, Spin, Tabs } from 'antd';
import { useNavigate } from 'react-router-dom';
import useProviderHomeInfo from 'hooks/useProviderHomeInfo';
import useCurrentUser from 'hooks/useCurrentUser';
import { ERoleCode } from 'types/enumItems';
import { getStep } from 'api/ppaOnboarding';
import { checkLeadFormByEmail } from 'api/ppaLeadForm';
import { isEhrOnlyHelpType } from 'pages/PPALeadFormPage/helpType';
import { INVITED_STEP_ROUTE, isInvitedProviderStep } from 'pages/InvitedProviderOnboarding/steps';
import useHomeConfig from 'hooks/useHomeConfig';
import type { TabsProps } from 'antd';
import KlarityInitStep1 from './components/KlarityInitStep1';
import KlarityInitStep2 from './components/KlarityInitStep2';
import KlarityInitStep3 from './components/KlarityInitStep3';
import KiwiInitStep1 from './components/KiwiInitStep1';
import KiwiInitStep2 from './components/KiwiInitStep2';
import KiwiInitStep3 from './components/KiwiInitStep3';
import KiwiInitStep4 from './components/KiwiInitStep4';
import KiwiInitStep5 from './components/KiwiInitStep5';
import KiwiInitPaid from './components/KiwiInitPaid';
import KlarityInitBg1 from 'assets/uniprofile/1.png';
import KlarityInitBg2 from 'assets/uniprofile/2.png';
import KlarityInitBg3 from 'assets/uniprofile/3.png';
import KlarityInitBg4 from 'assets/uniprofile/4.png';
import HomeStore from 'store/Home';
import { getViewMode } from 'utils/sessionStorage';
import {
    MODE,
    CALENDLY_LINK,
    isLocalhost,
    IS_BACK_FROM_STRIPE,
    ONBOARDING_WATCHED_INTRO_VIDEO,
    SHOW_KLARITY_ADVERTISING_ICON,
} from 'constants/common';
import { openUniprofileAgreementSignModal } from 'utils/globalLayerControl';
import SubscriptionStore from 'store/Subscription';
import { Provider } from 'types/provider';
import CommonStore from 'store/Common';
import ExploreKiwiHealth from './components/ExploreKiwiHealth';
import { PATH } from 'constants/path';
import {
    setSubscriptionCallbackPath,
    setHasShowAutoOnboardingPopup,
    getHasShowAutoOnboardingPopup,
    getHasShowWebinarModalInDashBoard,
    setHasShowWebinarModalInDashBoard,
    getUserId,
} from 'utils/localstore';
import InsuranceSurveyModal from 'components/InsuranceSurveyModal';
import useInsuranceSurvey from './hooks/useInsuranceSurvey';
import { isFreeUserByInfo } from 'utils/provider';
import GrowthHub from './components/GrowthHub';
import Schedule from 'pages/SalesProviderExp/components/Schedule';
import { EProfileStatus } from 'types/channel';
import WebinarBooking from 'components/WebinarBooking';
import IntroPopup from './components/OnboardingPopups/Intro';
import WebinarPopup from './components/OnboardingPopups/Webinar';
import CreateUniprofilePopup from './components/OnboardingPopups/CreateUniprofile';
import GetPlanPopup from './components/OnboardingPopups/GetPlan';
import ExploreChannelPopup from './components/OnboardingPopups/ExploreChannel';
import PaymentsPopup from './components/OnboardingPopups/Payments';
import OptChannelPopup from './components/OnboardingPopups/OptChannel';
import ServiceNAvailibilty from './components/OnboardingPopups/ServiceNAvailibilty';
import CalendlyPopup from './components/OnboardingPopups/Calendly';
import FirstLoginModal1 from './components/FirstLoginPopup/modal1';
import FirstLoginModal2 from './components/FirstLoginPopup/modal2';
import ProviderStore from 'store/Provider';
import Alert from 'components/Alert';
import Progress from './components/OnboardingPopups/progress';
import GlobalLayerStore from 'store/GlobalLayer';
import { ESource } from 'types/operation';
import StripeOnboardingComponent from 'components/StripeOnboardingComponent';
import { checkIsPaymentFailed } from 'api/ehr';
import { signKlarityHealthAgreement } from 'api/provider';
import CombinedBanner from './components/CombinedBanner';
import { Email } from 'constants/contact';
import JoinKiwiHealth from './components/JoinKiwiHealth';
import ResourcesHelp from './components/ResourcesHelp';
import SetupNoShow from './components/SetupNoShow';
import { shouldUseKlarityUi } from 'utils/common';
import useHomePopup from 'hooks/useHomePopup';
import { EHomePopupKey } from 'constants/homePopups';
import { EAgreementReviewType } from 'types/subscription';
import ProviderTermsUpdateModal from './components/ProviderTermsUpdateModal';

const ProviderHomePage = () => {
    const [getGlobalLayer] = GlobalLayerStore.useStore();
    const hideOtherModalsForAgreementSignModalEnabled = getGlobalLayer('hideOtherModalsForAgreementSignModal');
    const [getUser] = ProviderStore.useStore();
    const providerData = getUser('data');
    const [onboardingPopupStep, setOnboardingPopupStep] = useState(-1);
    const [firstLoginPopupStep, setFirstLoginPopupStep] = useState(1);
    const [getCommonStore, setCommonStore] = CommonStore.useStore();

    const [, contextHolder] = message.useMessage();
    const { data: channelListData = { data: { data: [] } } } = useRequest(getLiveChannelList) || {};
    let listData = channelListData?.data?.data?.filter((item: Channel) => {
        return item.listStatus === 'not-listed';
    });
    listData?.sort((a: ChannelItem, b: ChannelItem) => {
        if (a.top) {
            return -1;
        }
        if (b.top) {
            return 1;
        }
        return 0;
    });
    listData = listData?.slice(0, 6);
    const [data, loadingHome, fetchData] = useProviderHomeInfo();
    const navigate = useNavigate();
    const [currentUser] = useCurrentUser();
    const userRole = currentUser?.roleCode;
    const isStaff = [
        ERoleCode.GROUP_ADMINISTRATIVE_ASSISTANT,
        ERoleCode.GROUP_CLINICAL_ASSISTANT,
        ERoleCode.GROUP_PRACTICE_MANAGER,
    ].includes(userRole as ERoleCode);
    const [getHomeStore] = HomeStore.useStore();
    const showKlarityAdvertisingIcon = getCommonStore('showAdvertisingIcon');
    const [configList, loadingConfig] = useHomeConfig();
    const [currentInx, setCurrentInx] = useState(0);
    const itemList = configList || [];
    const currentItem = itemList?.[currentInx] || {
        title: '',
        headLine: '',
        content: '',
    };
    const practiceFrontCompleted = !!data?.practiceFrontCompleted;
    const uniprofileApproved = !!data?.uniprofileApproved;
    const uniprofileSubmitted = !!data?.uniprofileSubmitted;
    const uniprofileApproveCompleted = !!data?.uniprofileApproveCompleted;
    const ehrSetUpCompleted = !!data?.ehrSetUpCompleted;
    const agreementReviewTypeList = data?.agreementReviewTypeList;
    const klarityUserWithoutKiwiPlan = !!data?.klarityUserWithoutKiwiPlan;
    const klarityPlanOnboardingDone = !!data?.klarityStarterSetUpCompleted;
    const uniprofileStatus = data?.uniprofileStatus;
    const firstUniprofileApprovedAt = data?.firstUniprofileApprovedAt;
    const firstUniprofileSubmitAt = data?.firstUniprofileSubmitAt;
    const firstPracticeLaunchAt = data?.firstPracticeLaunchAt;
    const ehrSetUpCompletedAt = data?.ehrSetUpCompletedAt; //用户可能没有选择addon，导致之前的bug是这一步显示没有完成，但是后续步骤都完成了。所以如果用户没有选addon，也就是没有addpaid时间，那么就用这个时间作为完成时间以及第三步骤的过期计算的开始时间
    const firstAddOnPaidAt = data?.firstAddOnPaidAt || ehrSetUpCompletedAt;
    const addOnPaid = !!data?.firstAddOnPaidAt || !!ehrSetUpCompletedAt;
    const isKlarity = !!data?.klarityUser;
    const isHeadwayUser = !!(data?.signUpFrom === ESource.HEADWAY);
    const completedOnboarding = !!data?.completedOnboarding;

    // Invited (group) provider who hasn't finished onboarding shouldn't stay on
    // the dashboard — send them back to their unfinished onboarding step.
    useEffect(() => {
        if (getViewMode() === MODE.OPS_PREVIEW) {
            return undefined;
        }
        if (loadingHome || !data || completedOnboarding) {
            return undefined;
        }
        if (currentUser?.roleCode !== ERoleCode.GROUP_PROVIDER) {
            return undefined;
        }
        let cancelled = false;
        (async () => {
            const email = currentUser?.actingUser?.email;
            const leadRes = email ? await checkLeadFormByEmail({ email }) : undefined;
            // EHR-only 邀请的 provider（lead form intent=ehr）留在 dashboard，不强制 onboarding
            if (cancelled || isEhrOnlyHelpType(leadRes?.data?.data?.leadForm?.practiceHelpType)) return;
            const stepRes = await getStep();
            const saved = stepRes?.data?.data?.currentStep;
            if (cancelled) return;
            const target = isInvitedProviderStep(saved)
                ? INVITED_STEP_ROUTE[saved]
                : PATH.INVITED_PROVIDER_ONBOARDING_CREATE_PROFILE;
            if (target !== PATH.DASHBOARD) {
                navigate(target, { replace: true });
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [data, loadingHome, completedOnboarding, currentUser, navigate]);
    const firstLoginAt = data?.firstLoginAt;
    const isRegularUser = !!data?.isRegularUser;
    const isAvailabilitySetUpCompleted = !!data?.availabilitySetUpCompleted;
    const isKlarityServiceSetUpCompleted = !!data?.klarityServiceSetUpCompleted;
    const providerCalendlyScheduleRecords = data?.providerCalendlyScheduleRecords || [];
    const [activeKey, setActiveKey] = useState('');
    const shouldRefetch = getHomeStore('reload');
    const payPlan = SubscriptionStore.get('currentPlan');
    const isFreeUser = payPlan && isFreeUserByInfo(payPlan);
    const isPPAProvider = data?.ppaProvider;
    const showFreeUserStep = isFreeUser && !isKlarity;
    const practiceAndPaymentSetUpCompleted = !!data?.practiceAndPaymentSetUpCompleted;

    const [finishedStep, setFinishedStep] = useState(0);
    const [showOnboardingCalendlyPopup, setShowOnboardingCalendlyPopup] = useState(false);
    const [showOnboardingCalendlyScheduled, setShowOnboardingCalendlyScheduled] = useState(false);
    const [showWebinarPop, setShowWebinarPop] = useState(false);
    const [showWebinarBanner, setShowWebinarBanner] = useState(false);
    const [webinarLink, setWebinarLink] = useState('');
    const [webinarTitle, setWebinarTitle] = useState('');
    const [webinarDes, setWebinarDes] = useState('');
    const [webinarScheduleType, setWebinarScheduleType] = useState<EWebinarScheduleType>();
    const [onboardingCompletedPercent, setOnboardingCompletedPercent] = useState(100);
    const [hasWatchedVideo, setHasWatchedVideo] = useState(false);
    const [hasScheduledOnboardingWebinar, setHasScheduledOnboardingWebinar] = useState(false);
    const [hasShowWebinarPopInDashboard, setHasShowWebinarPopInDashboard] = useState(false);
    const [showPaymentTips, setShowPaymentTips] = useState(false);
    const serviceNAVailabilityIsCompleted = useMemo(
        () => isAvailabilitySetUpCompleted && isKlarityServiceSetUpCompleted,
        [isAvailabilitySetUpCompleted, isKlarityServiceSetUpCompleted],
    );

    const wrapperRef = useRef<HTMLDivElement>();
    const [showFirstLoginFlow, setShowFirstLoginFlow] = useState(false);

    const isGrowthHubPath =
        (!shouldUseKlarityUi() && completedOnboarding) || shouldUseKlarityUi() || getUserId() === 1446;

    const isBackFromStripe = sessionStorage.getItem(IS_BACK_FROM_STRIPE) === 'true';
    const agreementSignEligible = !!isKlarity && !isBackFromStripe && (agreementReviewTypeList?.filter((t) => t !== EAgreementReviewType.CREDENTIALING_AGREEMENT).length ?? 0) > 0;
    const { shouldShow: shouldShowAgreementSign } = useHomePopup(EHomePopupKey.AGREEMENT_SIGN, agreementSignEligible);

    const firstLoginEligible =
        !isGrowthHubPath && !!showFirstLoginFlow && !isKlarity && !loadingHome && onboardingCompletedPercent !== 100;
    const { shouldShow: shouldShowFirstLogin } = useHomePopup(EHomePopupKey.FIRST_LOGIN, firstLoginEligible);

    const isOver24hSinceFirstLogin =
        !!firstLoginAt && Date.now() - new Date(firstLoginAt).getTime() > 24 * 60 * 60 * 1000;

    const onboardingEligible =
        !isGrowthHubPath &&
        onboardingPopupStep > 0 &&
        !isKlarity &&
        !loadingHome &&
        onboardingCompletedPercent !== 100 &&
        isOver24hSinceFirstLogin;
    const { shouldShow: shouldShowOnboarding } = useHomePopup(EHomePopupKey.CREATE_UNIPROFILE, onboardingEligible);

    const calendlyEligible =
        !isGrowthHubPath && !!showOnboardingCalendlyPopup && !isKlarity && isOver24hSinceFirstLogin;
    const { shouldShow: shouldShowCalendly } = useHomePopup(EHomePopupKey.CALENDLY, calendlyEligible);

    const webinarEligible = !isGrowthHubPath && !!showWebinarPop && isOver24hSinceFirstLogin;
    const { shouldShow: shouldShowWebinar } = useHomePopup(EHomePopupKey.WEBINAR, webinarEligible);

    const termsUpdateEligible = !!agreementReviewTypeList?.includes(EAgreementReviewType.CREDENTIALING_AGREEMENT);
    const { shouldShow: shouldShowTermsUpdate, dismiss: dismissTermsUpdate } = useHomePopup(
        EHomePopupKey.TERMS_UPDATE,
        termsUpdateEligible,
    );
    const handleTermsAgree = async () => {
        try {
            const res = await signKlarityHealthAgreement();
            if (!res.error) {
                dismissTermsUpdate();
                fetchData();
            } else {
                message.error(res.error);
            }
        } catch {
            message.error('Failed to sign agreement. Please try again.');
        }
    };

    const paymentTipRender = async () => {
        try {
            const res = await checkIsPaymentFailed();
            setShowPaymentTips(Boolean(res.data?.data));
        } catch (e) {
            console.log(e);
        }
    };

    // 确保只进行一次判断
    // 放具有dependence的useEffect内判断的话，可能会因为dependence的变化而多次执行，导致一次页面打开，多次重复判断hasShowWebinarPopInCurrentSession
    React.useEffect(() => {
        setHasShowWebinarPopInDashboard(getHasShowWebinarModalInDashBoard());
        paymentTipRender();
    }, []);

    React.useEffect(() => {
        if (data && payPlan) {
            const _isKlarity = !!data?.klarityUser;
            const _isHeadwayUser = !!(data.signUpFrom === ESource.HEADWAY);
            let _webinarLink = CALENDLY_LINK.LEARN_ABOUT_UNIPROFILE;
            let _webinarTitle = 'Schedule "Learn about UniProfile webinar"';
            let _webinarDes =
                'Your UniProfile hasn\'t been submitted yet. Schedule the "Learn about UniProfile webinar" to get step-by-step assistance in completing your profile and ensuring it\'s ready for channel listings.';
            let _webinarScheduleType = EWebinarScheduleType.LEARN_ABOUT_UNIPROFILE;
            //1 UniProfile: Not Submit - Paid
            let showLearnAboutUniProfileWebinar = !data?.uniprofileSubmitted && !isFreeUser;
            const hasBookLearnAboutUniProfileWebinar = providerCalendlyScheduleRecords?.includes(
                EWebinarScheduleType.LEARN_ABOUT_UNIPROFILE,
            );
            showLearnAboutUniProfileWebinar = showLearnAboutUniProfileWebinar && !hasBookLearnAboutUniProfileWebinar;

            //2 UniProfile: Not Submit - UnPaid
            let showOnboardingWebinar = !data?.uniprofileSubmitted && isFreeUser;
            const hasBookOnboardingWebinar = providerCalendlyScheduleRecords?.includes(EWebinarScheduleType.ONBOARDING);
            if (showOnboardingWebinar) {
                _webinarLink = _isHeadwayUser ? CALENDLY_LINK.ONBOARDING : CALENDLY_LINK.INTRODUCTION_TO_KIWI;
                _webinarTitle = _isHeadwayUser
                    ? 'Schedule "Klarity Health Appointment webinar"'
                    : 'Schedule "Introduction to Kiwi webinar"';
                _webinarDes =
                    'See how we can help you grow your practice — no monthly or upfront fees, you only pay when a new appointment is booked.';
                _webinarScheduleType = EWebinarScheduleType.ONBOARDING;
            }
            showOnboardingWebinar = showOnboardingWebinar && !hasBookOnboardingWebinar;

            //3 UniProfile: Submitted - Paid
            //5 UniProfile: Approved - Paid
            //7 UniProfile: Not Approved - Paid
            let showOptimizationWebinar = data?.uniprofileSubmitted && !isFreeUser;
            if (!showOptimizationWebinar) {
                showOptimizationWebinar = data?.uniprofileApproved && !isFreeUser;
            }
            if (showOptimizationWebinar) {
                _webinarTitle = 'Schedule "Introduction to Kiwi webinar"';
                _webinarDes =
                    'To finalize your profile, attend the essential webinar to ensure your information is complete and optimized for channel listings.';
                _webinarLink = CALENDLY_LINK.UNIPROFILE_OPTIMISATION;
                _webinarScheduleType = EWebinarScheduleType.UNIPROFILE_OPTIMISATION;
            }
            const hasBookOptimizationWebinar = providerCalendlyScheduleRecords?.includes(
                EWebinarScheduleType.UNIPROFILE_OPTIMISATION,
            );
            showOptimizationWebinar = showOptimizationWebinar && !hasBookOptimizationWebinar;

            //6 UniProfile: Approved - UnPaid
            let showAccountActivationWebinar = data?.uniprofileApproved && isFreeUser;
            if (showAccountActivationWebinar) {
                _webinarTitle = 'Schedule "Account activation webinar"';
                _webinarDes =
                    "Your UniProfile is complete! Schedule a webinar to discover Kiwi's features, plans, and benefits — and ensure your UniProfile is fully complete.";
                _webinarLink = CALENDLY_LINK.ACCOUNT_ACTIVATION;
                _webinarScheduleType = EWebinarScheduleType.ACCOUNT_ACTIVATION;
            }
            const hasBookAccountActivationWebinar = providerCalendlyScheduleRecords?.includes(
                EWebinarScheduleType.ACCOUNT_ACTIVATION,
            );
            showAccountActivationWebinar = showAccountActivationWebinar && !hasBookAccountActivationWebinar;

            //8 UniProfile: Not Approved - UnPaid
            //9 UniProfile: Submitted - UnPaid
            let showIntroductionToKiwiWebinar = data?.uniprofileSubmitted && !data.uniprofileApproved && isFreeUser;
            if (showIntroductionToKiwiWebinar) {
                _webinarTitle = 'schedule “Klarity Health Appointment webinar”';
                _webinarDes =
                    'See how we can help you grow your practice — no monthly or upfront fees, you only pay when a new appointment is booked.';
                _webinarLink = CALENDLY_LINK.INTRODUCTION_TO_KIWI;
                _webinarScheduleType = EWebinarScheduleType.INTRODUCTION_TO_KIWI;
            }
            const hasBookIntroductionToKiwiWebinar = providerCalendlyScheduleRecords?.includes(
                EWebinarScheduleType.INTRODUCTION_TO_KIWI,
            );
            showIntroductionToKiwiWebinar = showIntroductionToKiwiWebinar && !hasBookIntroductionToKiwiWebinar;

            //!isKlarity && data?.uniprofileApproved || !data?.uniprofileSubmitted || !!isFreeUser
            const _showWebinarBanner =
                !_isKlarity &&
                (showLearnAboutUniProfileWebinar ||
                    showOnboardingWebinar ||
                    showOptimizationWebinar ||
                    showAccountActivationWebinar ||
                    showIntroductionToKiwiWebinar);
            let _showWebinarPop = _showWebinarBanner;

            if (hasShowWebinarPopInDashboard) {
                _showWebinarPop = false;
            }
            setWebinarTitle(_webinarTitle);
            setWebinarDes(_webinarDes);
            setWebinarLink(_webinarLink);
            setWebinarScheduleType(_webinarScheduleType);
            setShowWebinarPop(!!_showWebinarPop && !isRegularUser && !getHasShowWebinarModalInDashBoard());
            setShowWebinarBanner(!!_showWebinarBanner && !isRegularUser);

            if (_showWebinarPop) {
                setHasShowWebinarModalInDashBoard(true);
            }
        }
    }, [isFreeUser, data, payPlan, hasShowWebinarPopInDashboard, providerCalendlyScheduleRecords, isRegularUser]);

    useEffect(() => {
        const showAdvertisingIconLS = localStorage.getItem(SHOW_KLARITY_ADVERTISING_ICON);
        if (
            isFreeUser &&
            klarityUserWithoutKiwiPlan &&
            showAdvertisingIconLS !== '1' &&
            showAdvertisingIconLS !== '2'
        ) {
            // if (isFreeUser && showAdvertisingIconLS !== '1' && showAdvertisingIconLS !== '2') {

            localStorage.setItem(SHOW_KLARITY_ADVERTISING_ICON, '1');
            setCommonStore('showAdvertisingIcon', '1');
            //removed on 08/28
        }
    }, [showKlarityAdvertisingIcon, isFreeUser, klarityUserWithoutKiwiPlan, setCommonStore, getCommonStore]);

    useEffect(() => {
        if (typeof shouldRefetch === 'boolean' && shouldRefetch) {
            fetchData();
        }
    }, [shouldRefetch]);

    useEffect(() => {
        if (shouldShowAgreementSign) {
            openUniprofileAgreementSignModal('Confirm agreement of service', false);
        }
    }, [shouldShowAgreementSign]);

    useEffect(() => {
        let hasDone = false;
        if (uniprofileSubmitted || !isFreeUser || practiceFrontCompleted) {
            hasDone = true;
        }
        hasDone = !!data?.providerCalendlyScheduleRecords?.includes(CALENDLY_TYPE.ONBOARDING);

        setHasScheduledOnboardingWebinar(hasDone);
    }, [data, uniprofileSubmitted, isFreeUser, practiceFrontCompleted]);

    useEffect(() => {
        let hasDone = false;
        if (hasScheduledOnboardingWebinar || uniprofileSubmitted || !isFreeUser || practiceFrontCompleted) {
            hasDone = true;
        }

        hasDone = localStorage.getItem(ONBOARDING_WATCHED_INTRO_VIDEO) === 'true';
        setHasWatchedVideo(hasDone);
    }, [hasScheduledOnboardingWebinar, uniprofileSubmitted, isFreeUser, practiceFrontCompleted]);

    const completedOnboardingSteps = useMemo(() => {
        // return [hasWatchedVideo, serviceNAVailabilityIsCompleted, hasScheduledOnboardingWebinar, uniprofileSubmitted, !isFreeUser, practiceFrontCompleted, practiceAndPaymentSetUpCompleted];
        return [
            uniprofileSubmitted,
            serviceNAVailabilityIsCompleted,
            isPPAProvider,
            practiceFrontCompleted,
            practiceAndPaymentSetUpCompleted,
        ];
    }, [
        uniprofileSubmitted,
        serviceNAVailabilityIsCompleted,
        isPPAProvider,
        practiceFrontCompleted,
        practiceAndPaymentSetUpCompleted,
    ]);

    // uniprofileSubmitted, isFreeUser, practiceFrontCompleted
    useEffect(() => {
        setOnboardingCompletedPercent(
            Number((completedOnboardingSteps.filter((e) => e).length / completedOnboardingSteps.length).toFixed(2)) *
                100,
        );
    }, [completedOnboardingSteps]);

    const handleContinueToOnBoarding = useCallback(() => {
        const uncompletedStep = completedOnboardingSteps.findIndex((e) => !e);
        setOnboardingPopupStep(uncompletedStep || uncompletedStep === 0 ? uncompletedStep + 1 : -1);
    }, [completedOnboardingSteps]);

    useEffect(() => {
        if (!getHasShowAutoOnboardingPopup()) {
            handleContinueToOnBoarding();
            setHasShowAutoOnboardingPopup('true');
        }
    }, [handleContinueToOnBoarding]);

    const insuranceSurvey = useInsuranceSurvey(data);
    const { shouldShow: shouldShowInsuranceSurvey } = useHomePopup(
        EHomePopupKey.INSURANCE_SURVEY,
        insuranceSurvey.visible,
    );

    const insuranceSurveyStates = insuranceSurvey.states;

    const spinning = loadingHome || loadingConfig;

    const kiwiItems: TabsProps['items'] = [
        {
            key: '1',
            label: (
                <div className={`${s.kiwiTabText} ${uniprofileSubmitted ? s.tabCompleted : ''}`}>
                    Create your UniProfile
                </div>
            ),
            children: <KiwiInitStep3 className={s.step} isSubmittedUniproile={uniprofileSubmitted} />,
        },
        {
            key: '2',
            label: (
                <div
                    className={`${s.kiwiTabText} ${
                        isAvailabilitySetUpCompleted && isKlarityServiceSetUpCompleted ? s.tabCompleted : ''
                    }`}
                >
                    Set up services and availability
                </div>
            ),
            children: (
                <KiwiInitStep4
                    className={s.step}
                    isAvailabilitySetUpCompleted={isAvailabilitySetUpCompleted}
                    isKlarityServiceSetUpCompleted={isKlarityServiceSetUpCompleted}
                />
            ),
        },
        {
            key: '3',
            label: <div className={`${s.kiwiTabText} ${isPPAProvider ? s.tabCompleted : ''}`}>Join Klarity Health</div>,
            children: <JoinKiwiHealth className={s.step} />,
        },
        {
            key: '4',
            label: (
                <div className={`${s.kiwiTabText} ${practiceAndPaymentSetUpCompleted ? s.tabCompleted : ''}`}>
                    Set up your no-show policy and get paid
                </div>
            ),
            children: <SetupNoShow className={s.step} />,
        },
    ];

    const klarityItems = [
        {
            key: '1',
            label: (
                <div className={`${s.klarityTabText} ${firstUniprofileSubmitAt ? s.tabCompleted : ''}`}>
                    Complete UniProfile
                </div>
            ),
            // disabled: uniprofileApproveCompleted,
            children: (
                <KlarityInitStep1
                    firstUniprofileSubmitAt={firstUniprofileSubmitAt}
                    uniprofileStatus={uniprofileStatus}
                    firstLoginAt={firstLoginAt}
                    className={s.step}
                    isSubmittedUniproile={uniprofileSubmitted}
                />
            ),
        },
        klarityUserWithoutKiwiPlan
            ? {
                  key: '2',
                  label: (
                      <div className={`${s.klarityTabText} ${addOnPaid ? s.tabCompleted : ''}`}>
                          Set up your practice
                      </div>
                  ),
                  // disabled: ehrSetUpCompleted && addOnPaid,
                  children: (
                      <ExploreKiwiHealth
                          firstAddOnPaidAt={firstAddOnPaidAt}
                          uniprofileStatus={uniprofileStatus}
                          addOnPaid={addOnPaid}
                          firstUniprofileSubmitAt={firstUniprofileSubmitAt}
                          uniprofileSubmitted={uniprofileSubmitted}
                          ehrSetUpCompleted={ehrSetUpCompleted}
                      />
                  ),
              }
            : undefined,
        {
            key: '3',
            label: (
                <div className={`${s.klarityTabText} ${practiceFrontCompleted ? s.tabCompleted : ''}`}>
                    Explore Kiwi Health
                </div>
            ),
            children: (
                <KlarityInitStep2
                    firstAddOnPaidAt={firstAddOnPaidAt}
                    addOnPaid={addOnPaid}
                    uniprofileStatus={uniprofileStatus}
                    firstPracticeLaunchAt={firstPracticeLaunchAt}
                    uniprofileApproveCompleted={uniprofileApproveCompleted}
                    className={s.step}
                    flag={uniprofileApproveCompleted && !ehrSetUpCompleted}
                    isEhrSetUpCompleted={ehrSetUpCompleted}
                    practiceFrontCompleted={practiceFrontCompleted}
                />
            ),
        },
        // {
        //     key: '4',
        //     label: 'Explore practice enablement add-ons',
        //     children: (
        //         <KlarityInitStep3 className={s.step} flag={ehrSetUpCompleted} />
        //     ),
        // },
    ].filter((e) => !!e);

    useEffect(() => {
        if (isKlarity) {
            if (!uniprofileSubmitted) {
                setActiveKey('1');
                setFinishedStep(0);
                return;
            }
            if ((!ehrSetUpCompleted || !addOnPaid) && klarityUserWithoutKiwiPlan) {
                setActiveKey('2');
                setFinishedStep(1);
                return;
            }
            if (uniprofileSubmitted && ehrSetUpCompleted && addOnPaid) {
                setActiveKey('3');
                setFinishedStep(2);
            }

            if (practiceFrontCompleted) {
                setFinishedStep(3);
            }
        } else {
            if (!uniprofileSubmitted) {
                setActiveKey('1');
                return;
            }
            if (!isPPAProvider) {
                setActiveKey('2');
                return;
            }
            if (!practiceAndPaymentSetUpCompleted) {
                setActiveKey('3');
                return;
            }
            setActiveKey('1');
        }
    }, [
        isKlarity,
        ehrSetUpCompleted,
        uniprofileApproveCompleted,
        uniprofileApproved,
        practiceFrontCompleted,
        uniprofileSubmitted,
        klarityUserWithoutKiwiPlan,
        isFreeUser,
        addOnPaid,
        hasScheduledOnboardingWebinar,
        hasWatchedVideo,
        practiceAndPaymentSetUpCompleted,
    ]);

    const handleChangeTab = (key: string) => {
        setActiveKey(key);
    };

    // const initClass = useMemo(() => {
    //     if (isKlarity) {
    //         return {};
    //     }

    //     let bgImage = KlarityInitBg1;

    //     if (activeKey === '1') {
    //         bgImage = KlarityInitBg1;
    //     }
    //     if (activeKey === '2') {
    //         bgImage = KlarityInitBg2;
    //     }
    //     if (activeKey === '3') {
    //         bgImage = KlarityInitBg3;
    //     }
    //     if (activeKey === '4') {
    //         bgImage = KlarityInitBg4;
    //     }
    //     return {
    //         backgroundImage: `url(${bgImage})`,
    //     };
    // }, [isKlarity, activeKey]);

    const initClassName = useMemo(() => {
        if (isKlarity) {
            return '';
        }
        if (activeKey === '1') {
            return s.tabActive1;
        }
        if (activeKey === '2') {
            return s.tabActive2;
        }
        if (activeKey === '3') {
            return s.tabActive3;
        }
        if (activeKey === '4') {
            return s.tabActive4;
        }
        return '';
    }, [isKlarity, activeKey]);

    const renderInit = () => {
        return (
            <div className={`${s.KlarityInitWrap} ${initClassName}`}>
                <h2 className={s.initTitle}>
                    {isKlarity
                        ? `Setup checklist for your Klarity practice (${finishedStep}/3 completed)`
                        : 'Get started'}
                </h2>
                <Tabs
                    className={s.tabBorder}
                    activeKey={activeKey}
                    onChange={(currentKey) => handleChangeTab(currentKey)}
                    tabPosition="left"
                    items={isKlarity ? (klarityItems as TabsProps['items']) : kiwiItems}
                    animated={{ inkBar: false, tabPane: false }}
                />
            </div>
        );
    };

    useEffect(() => {
        setShowFirstLoginFlow(!firstLoginAt);
    }, [firstLoginAt]);

    const onboardingPopupRender = useMemo(() => {
        if (!shouldShowOnboarding) {
            return null;
        }

        let content = null;
        const commomProps = {
            setOnboardingPopupStep,
            onClosePopup: () => {
                setOnboardingPopupStep(-1);
            },
        };
        if (onboardingPopupStep === 1) {
            content = <CreateUniprofilePopup {...commomProps} uniprofileSubmitted={uniprofileSubmitted} />;
        }
        if (onboardingPopupStep === 2) {
            content = (
                <ServiceNAvailibilty
                    {...commomProps}
                    isAvailabilitySetUpCompleted={isAvailabilitySetUpCompleted}
                    isKlarityServiceSetUpCompleted={isKlarityServiceSetUpCompleted}
                />
            );
        }
        if (onboardingPopupStep === 3) {
            content = <OptChannelPopup {...commomProps} isPPAProvider={isPPAProvider} />;
        }
        if (onboardingPopupStep === 4) {
            content = (
                <PaymentsPopup {...commomProps} practiceAndPaymentSetUpCompleted={practiceAndPaymentSetUpCompleted} />
            );
        }

        return (
            content && (
                <Modal
                    getContainer={wrapperRef.current}
                    className={s.onboardingModal}
                    open
                    width={534}
                    footer={null}
                    closable={false}
                >
                    {content}
                </Modal>
            )
        );
    }, [
        shouldShowOnboarding,
        onboardingPopupStep,
        uniprofileSubmitted,
        isAvailabilitySetUpCompleted,
        isKlarityServiceSetUpCompleted,
        isPPAProvider,
        practiceAndPaymentSetUpCompleted,
    ]);

    const firstLoginPopupRender = useMemo(() => {
        if (!shouldShowFirstLogin) {
            return null;
        }

        let content = null;
        const commomProps = {
            setFirstLoginPopupStep,
            onClosePopup: () => {
                setFirstLoginPopupStep(-1);
            },
            onFinishFlow: () => {
                setFirstLoginPopupStep(-1);
                setShowFirstLoginFlow(false);
            },
        };
        if (firstLoginPopupStep === 1) {
            content = <FirstLoginModal1 {...commomProps} />;
        }
        if (firstLoginPopupStep === 2) {
            content = <FirstLoginModal2 {...commomProps} />;
        }

        return (
            content && (
                <Modal
                    getContainer={wrapperRef.current}
                    className={s.onboardingModal}
                    open
                    width={534}
                    footer={null}
                    closable={false}
                >
                    {content}
                </Modal>
            )
        );
    }, [shouldShowFirstLogin, firstLoginPopupStep]);

    const onCloseWebinarPop = (isSuccess: boolean) => {
        setShowWebinarPop(false);
        if (isSuccess) {
            fetchData();
        }
    };

    const onScheduled = () => {
        fetchData();
    };

    const hasAgreement =
        payPlan?.couponType !== CouponType.HEADWAY && agreementReviewTypeList && agreementReviewTypeList.length > 0;

    const insuranceSurveyModalRender = shouldShowInsuranceSurvey ? (
        <InsuranceSurveyModal
            visible={shouldShowInsuranceSurvey}
            states={insuranceSurveyStates}
            initialInsuranceSettings={insuranceSurvey.initialInsuranceSettings}
            onSkip={insuranceSurvey.dismiss}
            onSave={insuranceSurvey.save}
        />
    ) : null;

    const apiDone = !!data;
    if (!apiDone) {
        return insuranceSurveyModalRender;
    }

    //completedOnboarding 只有kiwi的情况有用，其他情况没用, kalrity的直接显示growth hub页面
    if ((!shouldUseKlarityUi() && completedOnboarding) || shouldUseKlarityUi() || getUserId() === 1446) {
        return (
            <>
                {insuranceSurveyModalRender}
                <ProviderTermsUpdateModal open={shouldShowTermsUpdate} onAgree={handleTermsAgree} />
                <GrowthHub
                    showWebinarBanner={showWebinarBanner}
                    webinarTitle={webinarTitle}
                    webinarDes={webinarDes}
                    webinarLink={webinarLink}
                    webinarScheduleType={webinarScheduleType}
                    onCloseWebinarPop={onCloseWebinarPop}
                    showWebinarPop={shouldShowWebinar}
                    onScheduled={onScheduled}
                />
            </>
        );
    }

    return (
        <Spin tip="Loading" size="large" spinning={spinning}>
            <div
                className={`${s.wrapper} ${!isKlarity ? s.kiwiWrapper : ''}`}
                ref={wrapperRef as React.RefObject<HTMLDivElement>}
            >
                {firstLoginPopupRender}
                {onboardingPopupRender}
                {insuranceSurveyModalRender}
                <ProviderTermsUpdateModal open={shouldShowTermsUpdate} onAgree={handleTermsAgree} />
                {!isKlarity && onboardingCompletedPercent !== 100 && (
                    <div className={s.onboardingProcess} onClick={handleContinueToOnBoarding}>
                        <div className={s.progressBar}>
                            <Progress value={onboardingCompletedPercent} />
                        </div>
                        Complete onboarding
                    </div>
                )}
                {shouldShowCalendly && providerData && (
                    <CalendlyPopup
                        isHeadway={isHeadwayUser}
                        onClose={() => setShowOnboardingCalendlyPopup(false)}
                        provider={providerData as Provider}
                        onBoardingCanlendlyScheduled={() => {
                            setShowOnboardingCalendlyPopup(false);
                            setHasScheduledOnboardingWebinar(true);
                            setShowOnboardingCalendlyScheduled(true);
                        }}
                    />
                )}
                <div className={s.inner}>
                    {contextHolder}
                    <div className={s.header}>
                        <div className={s.title}>Welcome 👋</div>
                    </div>
                    {showOnboardingCalendlyScheduled && (
                        <Alert
                            innerHtml="🎊 Webinar scheduled successfully! <br/> <span style='padding-left: 17px;'>Your session is confirmed! Be sure to attend your webinar on time to get the most out of Kiwi and grow your practice.</span>"
                            onClose={() => setShowOnboardingCalendlyScheduled(false)}
                        />
                    )}
                    {/* {
                        (hasAgreement || showWebinarBanner || showPaymentTips) && (
                            <div className={s.bannerWrap}>
                                <CombinedBanner
                                    fetchData={fetchData}
                                    webinarTitle={webinarTitle}
                                    webinarDes={webinarDes}
                                    webinarLink={webinarLink}
                                    webinarScheduleType={webinarScheduleType}
                                    hasAgreement={hasAgreement}
                                    showPaymentTips={showPaymentTips}
                                />
                            </div>
                        )
                    } */}
                    <div className={s.initWrap}>
                        <div className={`${s.left} ${isKlarity ? s.klarityInitLeft : ''}`}>{renderInit()}</div>
                        {/* {!isKlarity && (
                            <div className={s.right}>
                                <div className={s.panel}>
                                    <div className={s.pTitle}>
                                        <h3>{currentItem.title}</h3>
                                        <div className={s.switch}>
                                            <span
                                                onClick={() => {
                                                    if (currentInx === 0) {
                                                        return;
                                                    }
                                                    setCurrentInx(currentInx - 1);
                                                }}
                                                className={
                                                    currentInx !== 0
                                                        ? `${s.sLeft} ${s.sLeftEnable}`
                                                        : s.sLeft
                                                }
                                            >
                                                {'<'}
                                            </span>
                                            <span className={s.val}>
                                                {currentInx + 1}/{itemList.length}
                                            </span>
                                            <span
                                                onClick={() => {
                                                    if (currentInx === itemList.length - 1) {
                                                        return;
                                                    }
                                                    setCurrentInx(currentInx + 1);
                                                }}
                                                className={
                                                    currentInx < itemList.length - 1
                                                        ? `${s.sRight} ${s.sRightEnable}`
                                                        : s.sRight
                                                }
                                            >
                                                {'>'}
                                            </span>
                                        </div>
                                    </div>
                                    <div className={s.pContentWrap}>
                                        <div
                                            className={s.pContentInner}
                                            style={{
                                                transform: `translateX(-${currentInx * 33.3}%)`,
                                            }}
                                        >
                                            {itemList?.map((item, inx) => {
                                                return (
                                                    <div
                                                        style={{ left: `${inx * 33.3}%` }}
                                                        className={s.pContent}
                                                        key={item.title}
                                                    >
                                                        <h3>{item.headLine}</h3>
                                                        <div className={s.pDes}>{item.content}</div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )} */}
                    </div>
                    {!(isKlarity && klarityUserWithoutKiwiPlan) && (
                        <div className={s.introWrap}>
                            <ResourcesHelp />
                            <div className={s.right}>
                                <div className={s.panel}>
                                    <div className={s.pTitle}>
                                        <h3>{currentItem.title}</h3>
                                        <div className={s.switch}>
                                            <span
                                                onClick={() => {
                                                    if (currentInx === 0) {
                                                        return;
                                                    }
                                                    setCurrentInx(currentInx - 1);
                                                }}
                                                className={currentInx !== 0 ? `${s.sLeft} ${s.sLeftEnable}` : s.sLeft}
                                            >
                                                {'<'}
                                            </span>
                                            <span className={s.val}>
                                                {currentInx + 1}/{itemList.length}
                                            </span>
                                            <span
                                                onClick={() => {
                                                    if (currentInx === itemList.length - 1) {
                                                        return;
                                                    }
                                                    setCurrentInx(currentInx + 1);
                                                }}
                                                className={
                                                    currentInx < itemList.length - 1
                                                        ? `${s.sRight} ${s.sRightEnable}`
                                                        : s.sRight
                                                }
                                            >
                                                {'>'}
                                            </span>
                                        </div>
                                    </div>
                                    <div className={s.pContentWrap}>
                                        <div
                                            className={s.pContentInner}
                                            style={{
                                                transform: `translateX(-${currentInx * 33.3}%)`,
                                            }}
                                        >
                                            {itemList?.map((item, inx) => {
                                                return (
                                                    <div
                                                        style={{
                                                            left: `${inx * 33.3}%`,
                                                        }}
                                                        className={s.pContent}
                                                        key={item.title}
                                                    >
                                                        <h3>{item.headLine}</h3>
                                                        <div className={s.pDes}>{item.content}</div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {/* {!(isKlarity && klarityUserWithoutKiwiPlan) && (
                        <div className={s.body}>
                            <h3>
                                Explore the most popular marketing channels for healthcare
                                practices
                            </h3>
                            <div className={s.rChannelWrap}>
                                {listData?.map((item: Channel) => {
                                    return (
                                        <div key={item.id} className={s.rChannelItem}>
                                            <ChannelCard key={item.id} item={item} />
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )} */}
                </div>
                <WebinarBooking
                    modalHeader={
                        <div className={s.wHeader}>
                            <div className={s.wTitle}>
                                <span className={s.wHigh}>!!</span>
                                Don’t miss out:
                                {webinarTitle?.replace('Schedule', 'schedule')}
                            </div>
                            <div className={s.wDes}>{webinarDes}</div>
                        </div>
                    }
                    show={false}
                    link={webinarLink}
                    webinarScheduleType={webinarScheduleType}
                    onClose={(isSuccess: boolean) => {
                        setShowWebinarPop(false);
                        if (isSuccess) {
                            fetchData();
                        }
                    }}
                />
            </div>
        </Spin>
    );
};

export default ProviderHomePage;
